import { render } from "./BucketItem.vue?vue&type=template&id=66649b58&scoped=true&ts=true"
import script from "./BucketItem.vue?vue&type=script&lang=ts"
export * from "./BucketItem.vue?vue&type=script&lang=ts"

import "./BucketItem.vue?vue&type=style&index=0&id=66649b58&scoped=true&lang=scss"

import exportComponent from "/Users/goyuntae/Desktop/bucket-list/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66649b58"]])

export default __exports__